module.exports = __webpack_public_path__ + "static/media/photo-11.1a316fff.avif";